import type React from 'react'
import { useEffect } from 'react'
import styled from '@emotion/styled'

import 'web-client/utils/bridge'
import Header from 'web-client/components/Header'
import { usePrevious } from 'web-client/hooks/usePrevious'
import { useRoute, useRouter } from 'react-router5'
import Footer from 'web-client/components/EnterpriseBorder/EnterpriseFooter'
import useCurrentUser from 'web-client/hooks/useCurrentUser'

type Props = {
  children: React.ReactNode
  hideFooter?: boolean
  requireAuthentication?: boolean
}

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  min-height: 100vh;
  padding: 0;
`

const Main = styled.main`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin: 0;
  padding: 0;
`

const Layout = ({ children, hideFooter, requireAuthentication }: Props) => {
  const router5Context = useRoute()
  const prevRouteName = usePrevious(router5Context.route?.name ?? '')
  useEffect(() => {
    if (prevRouteName !== router5Context.route?.name) {
      // TODO: log the route change
    }
  }, [prevRouteName, router5Context.route])

  const { isLoggedIn } = useCurrentUser()

  // TODO: Lift this code higher in the tree, to LazyLoader.js;
  // Why not now? Because this currently impacts only our limited number of "Greenfield"
  // routes. If we lift it, it will wrap the entire app, increasing risk.
  // We should save this task for another day; ticketed as ENG-25491
  const router = useRouter()
  useEffect(() => {
    if (requireAuthentication) {
      if (!isLoggedIn) {
        router.navigate('login', { returnUrl: window.location.pathname })
      }
    }
  })
  if (requireAuthentication && !isLoggedIn) {
    return null
  }

  return (
    <PageWrapper>
      <Header />
      <Main>{children}</Main>
      {!hideFooter && <Footer />}
    </PageWrapper>
  )
}

export default Layout
